import React from "react";

import free from "../../assets/Core-icons/sticky/icone.png";
import count from "../../assets/Core-icons/sticky/ictwo.png";
import go from "../../assets/Core-icons/sticky/icthree.png";

import Mask_group from "../../assets/Services/mobile_app_img/Mask_group.png";
import Mask_group2 from "../../assets/Services/mobile_app_img/Mask_group2.png";
import Mask_group3 from "../../assets/Services/mobile_app_img/Mask_group3.png";

const CoreComponent3 = () => {
  return (
    <div className="container mt-80 d-flex justify-content-center flex-column align-items-center">
      <h2 className="mb-4 text-center pb-2 h2-heading ">
        Bringing Innovation to Your Fingertips
      </h2>

      <div
        className="row bg-danger h-100 p-4 rounded-4 position-sticky  z-1 shadow-lg"
        style={{ width: "100%", top: 100 }}
      >
        <div className="col-lg-3  d-flex flex-column  ">
          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading ">4.8 </h2>
              <span className="text-white h1-para">App Rating</span>
            </div>
          </div>
          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading">10 L </h2>
              <span className="text-white h1-para">Download</span>
            </div>
          </div>

          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita  h2-heading">1 L </h2>
              <span className="text-white h1-para mt-2">Live Users</span>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <img
            src={go}
            style={{ width: "" }}
            className="big-img d-none d-lg-block"
          />
        </div>

        <div className="col-lg-6  d-flex flex-column justify-content-center">
          <div className="border-bottom pb-4 mb-4">
            <strong className="fs-2 mb-3 d-block text-white h2-heading text-start mt-4 mt-lg-0">
              Freletics{" "}
            </strong>
            <span className="fs-5 mb-3  text-white h1-para">
              Wherever you are, your personal fitness coach can help you achieve
              your goals with flexible workout plans.
            </span>
          </div>

          <div className="border-bottom d-flex">
            <img
              src={Mask_group}
              alt=""
              style={{ height: 60, width: 68 }}
              className="rounded-circle m-0"
            />
            <div className="ms-3  pb-4">
              <p className="  text-white">Sofia Rossi</p>
              <p className="mt-2  text-white fs-6 ">
                Freletics keeps me incredibly motivated and strong, even on busy
                days!
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="row d-flex h-100 justify-content-center align-items-center bg-info p-4 rounded-4 position-sticky top-0 z-2 shadow-lg"
        style={{ width: "100%", height: 510, top: 100 }}
      >
        <div className="col-lg-3  d-flex flex-column  ">
          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita  h2-heading">4.9 </h2>
              <span className="text-white h1-para">App Rating</span>
            </div>
          </div>
          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading">1 L </h2>
              <span className="text-white h1-para">Download</span>
            </div>
          </div>

          <div className="border-bottom border-white text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading ">50K </h2>
              <span className="text-white h1-para">Live Users</span>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <img src={free} style={{ width: "" }} className="big-img" />
        </div>

        <div className="col-lg-6 d-flex flex-column justify-content-center">
          <div className="border-bottom pb-4 mb-4">
            <strong className="fs-2 mb-3 d-block text-white h3-heading text-start mt-4 mt-lg-0 ">
              Gosnack
            </strong>
            <span className="fs-5 mb-3  text-white h1-para">
              Discover, order, and review delicious local food with ease. Your
              next meal is just a tap away!
            </span>
          </div>

          <div className="border-bottom d-flex">
            <img
              src={Mask_group2}
              alt=""
              style={{ height: 60, width: 68 }}
              className="rounded-circle m-0"
            />
            <div className="ms-3  pb-4">
              <p className="  text-white">Hiroshi Tanaka</p>
              <p className="mt-2  text-white fs-6">
                Gosnack is a lifesaver! Finding great food quickly has never
                been easier.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div
        className="row  p-4 rounded-4 h-100 position-sticky top-0 z-3 shadow-lg"
        style={{ width: "100%", background: "#90ee90", top: 100 }}
      >
        <div className="col-lg-3  d-flex flex-column  ">
          <div className="custom-border-bottom  text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading">4.8 </h2>
              <span className="text-white h1-para  ">App Rating</span>
            </div>
          </div>
          <div className="custom-border-bottom  text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading ">9 L </h2>
              <span className="text-white h1-para">Download</span>
            </div>
          </div>

          <div className="custom-border-bottom  text-center">
            <div className="my-4 ">
              <h2 className=" text-white font-gordita h2-heading">3L </h2>
              <span className="text-white h1-para ">Live Users</span>
            </div>
          </div>
        </div>
        <div className="col-lg-3">
          <img src={count} style={{ width: "" }} className="big-img" />
        </div>

        <div className="col-lg-6 d-flex flex-column justify-content-center">
          <div className=" custom-border-bottom pb-4 mb-4">
            <strong className="fs-2 mb-3 d-block text-white h3-heading text-start mt-4 mt-lg-0 ">
              Courtri
            </strong>
            <span className="fs-5 mb-3  text-white h1-para ">
              Book and manage sports turf facilities effortlessly, making it
              simple to find your perfect game space.
            </span>
          </div>

          <div className=" d-flex custom-border-bottom">
            <img
              src={Mask_group3}
              alt=""
              style={{ height: 60, width: 68 }}
              className="rounded-circle m-0"
            />
            <div className="ms-3  pb-4">
              <p className="  text-white">Evelyn</p>
              <p className="mt-2  text-white fs-6">
                Courtri-Turf is fantastic! In just a few minutes, we can always
                locate and reserve a fantastic turf.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CoreComponent3;
